/**
 * Emergent Themes — sentiment badge derivation.
 *
 * The close pipeline's ThemeService stores a numeric `signal_strength` (0-100)
 * on every theme. It already encodes sentiment direction (see the THEME_EXTRACTION
 * prompt banding). There is no discrete sentiment label in the payload — the score
 * IS the badge. This maps a score onto the label + badge variant used in the UI.
 */
export type SentimentVariant = 'very-negative' | 'negative' | 'neutral' | 'positive' | 'very-positive';

export interface SentimentBand {
  label: string;
  variant: SentimentVariant;
}

/** Same thresholds the AI prompt uses to assign signal_strength. */
export function sentimentForSignal(signalStrength: number | undefined | null): SentimentBand {
  const score = typeof signalStrength === 'number' ? signalStrength : 50;
  if (score < 20) return { label: 'Very Negative Feedback', variant: 'very-negative' };
  if (score < 40) return { label: 'Negative Feedback', variant: 'negative' };
  if (score < 60) return { label: 'Mixed Feelings', variant: 'neutral' };
  if (score < 80) return { label: 'Positive Feedback', variant: 'positive' };
  return { label: 'Very Positive Feedback', variant: 'very-positive' };
}
